import 'bootstrap/js/dist/modal';
import $ from 'jquery';
import {compose} from 'ramda';
import axios from 'axios';
import {setUserOver18YearsOld} from '~/api/other';

/** @typedef { import('axios').CancelTokenSource } CancelTokenSource */

const allowAllCards = () => $('.product-card').removeAttr('data-adult-content');

export default function initAdultModal(modalElement) {
    // In order to prevent backdrop dublicating by bootstrap,
    // we have to clone and initialize modal on our own and replace initial
    const initialModal = modalElement;
    const initialBackdrop = document.querySelector('.modal-backdrop');
    const modal = initialModal.cloneNode(true);

    // Lift up initial elements to hide routine
    initialModal.style.setProperty('z-index', 10000);
    initialBackdrop.style.setProperty('z-index', 10000);

    // Append modal
    document.body.appendChild(modal);

    // Init modal
    $(modal).modal({backdrop: 'static', show: true});

    // Get backdrop element
    const {_backdrop: backdrop} = $(modal).data('bs.modal');

    // Prevent transitions
    backdrop.style.setProperty('transition', 'none');

    // Merge classes of initial and initialized backdrops
    backdrop.classList.value = initialBackdrop.classList.value;

    // Reset transitions on next frame
    window.requestAnimationFrame(() =>
        backdrop.style.removeProperty('transition')
    );

    // Remove initial elements
    initialModal.remove();
    initialBackdrop.remove();

    // Bind events
    /** @type {boolean} */
    let confirmFlag;
    /** @type {CancelTokenSource} */
    let cancelToken;
    const confirm = modal.querySelector('[data-adult="confirm"]');

    const disposeModal = () => $(modal).modal('dispose');
    const removeModal = () => modal.remove();
    const redirectIfNotConfirmed = (event) => {
        if (confirmFlag)
            return;

        event.preventDefault();
        location.replace('/');
    }
    const onModalHidden = compose(
        allowAllCards,
        removeModal,
        disposeModal,
    );

    $(modal).on('hide.bs.modal', redirectIfNotConfirmed);
    $(modal).on('hidden.bs.modal', onModalHidden);

    confirm.addEventListener('click', async () => {
        if (cancelToken)
            cancelToken.cancel('Cancelled by user repeated click');

        cancelToken = axios.CancelToken.source();
        confirmFlag = await setUserOver18YearsOld({
            cancelToken: cancelToken.token,
        });

        $(modal).modal('hide');
    });
}
